"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateCalculationMutation = exports.updateCalculationFinancingMutation = exports.createCalculationMutation = void 0;
const fragments_1 = require("../../types/next/fragments");
exports.createCalculationMutation = `
  mutation createCalculation($input: CalculationInput!, $orderId: String!) {
    createCalculation(input: $input, orderId: $orderId) {
      ...calculation
    }
  }
  ${fragments_1.calculationFragments}
`;
exports.updateCalculationFinancingMutation = `
  mutation($calculationId: String!, $input: CommonFinancingInput!) {
    updateCalculationFinancing(id: $calculationId, input: $input) {
      ...calculation
    }
  }
  ${fragments_1.calculationFragments}
`;
exports.updateCalculationMutation = `
  mutation($calculationId: String!, $input: CalculationInput!) {
    updateCalculation(id: $calculationId, input: $input) {
      ...calculation
    }
  }
  ${fragments_1.calculationFragments}
`;
//# sourceMappingURL=calculation.js.map